import dotenv from 'dotenv';
import pkg from './package.json';

dotenv.load({ silent: true });

const { argv, env } = process;

const SUB_DIR = ''; // 'ahrend/'

const base = {
  src: './src',
  dist: './dist',
  docs: './tasks/docs',
};

module.exports = {
  base: {
    src: base.src,
    dist: base.dist,
    docs: base.docs,
  },

  browsersync: {
    server: {
      baseDir: base.dist,
    },
    open: false,
    ui: false,
    notify: false,
    https: argv.includes('--https'),
    port: 3003,
  },

  clean: {
    dist: {
      base: base.dist,
    },
  },

  css: {
    src: {
      static: `${base.src}/static/scss/**/!(_)*.scss`,
      staticAll: `${base.src}/static/scss/**/*.scss`,
      components: `${base.src}/components/**/*.scss`,
      vendor: `${base.src}/static/scss/vendor/**/*.scss`,
    },
    dist: {
      base: `${base.dist}/static/${SUB_DIR}css`,
    },
  },

  docs: {
    src: {
      index: `${base.docs}/index.njk`,
      indexDir: base.docs,
      layoutDir: `${base.docs}/layout`,
      templates: `${base.src}/templates`,
      statics: `${base.docs}/static/**`,
      component: 'component-detail.njk',
      preview: 'component-preview.njk',
      components: `${base.src}/components`,
      componentsAll: `${base.src}/components/**/*.yml`,
      componentsData: `${base.src}/components/**/*.json`,
    },
    dist: {
      base: base.dist,
      index: `${base.dist}/index.html`,
      static: `${base.dist}/docs/static/`,
      components: `${base.dist}/docs/components/`,
    },
    codeBeautifier: {
      'indent-size': 2,
      'max-preserve-newlines': 0,
    },
  },

  codestyle: {
    glob: '**/*.{md,css,scss,js,json,yml}',
    ignorefile: '.lintignore',
  },

  fonts: {
    src: {
      fonts: `${base.src}/static/fonts/**/*.{woff,woff2,css}`,
    },
    dist: {
      fonts: `${base.dist}/static/${SUB_DIR}fonts`,
    },
  },

  mock: {
    src: {
      mock: `${base.src}/mock/**/*`,
    },
    dist: {
      mock: `${base.dist}/mock`,
    },
  },

  html: {
    src: {
      templates: `${base.src}/templates/**/*.njk`,
      templatesDir: `${base.src}/templates`,
      templatesData: `${base.src}/templates/**/*.json`,
      layout: `${base.src}/layout/*.njk`,
      layoutDir: `${base.src}/layout`,
      components: `${base.src}/components/**/*.njk`,
      componentsDir: `${base.src}/components`,
      componentsData: `${base.src}/components/**/*.json`,
    },
    dist: {
      base: `${base.dist}/templates`,
    },
    baseUri: '/',
  },

  img: {
    src: {
      all: `${base.src}/static/${SUB_DIR}img/**/*.{svg,png,jpg,gif,webp}`,
      spritesheetDir: `${base.src}/static/sprites`,
    },
    dist: {
      base: `${base.dist}/static/${SUB_DIR}img`,
    },
    spritesheet: {
      shape: {
        id: {
          separator: '-',
          whitespace: '-',
        },
      },
      mode: {
        symbol: {
          bust: false,
          dest: './',
          sprite: `${base.dist}/static/${SUB_DIR}img/sprite.svg`,
        },
      },
    },
  },

  js: {
    src: {
      all: `${base.src}/static/js/**/*.js`,
      bundles: `${base.src}/static/js/*.js`,
      components: `${base.src}/components/**/!(*.Spec).js`,
      vendor: `${base.src}/static/js/vendor`,
      tests: `${base.src}/components/**/*.Spec.js`,
    },
    dist: {
      base: `${base.dist}/static/${SUB_DIR}js`,
      babelHelpers: `${base.dist}/static/js/babel-helpers.js`,
    },
    browserify: {
      paths: [`${base.src}/static/js/`, `${base.src}/components/`],
      debug: true,
      // Keep in config, we concat 'watchify' when running 'gulp dev'
      plugin: ['errorify'],
      transform: ['babelify', 'require-globify'],
    },
    eslintAutofix: false,
  },
};
